import "prism-themes/themes/prism-dracula.css";
import "prismjs/plugins/command-line/prism-command-line.css";

import QueryWrapper from "./src/context/QueryWrapper";

// eslint-disable-next-line import/prefer-default-export
export const wrapRootElement = QueryWrapper;
